var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnpinned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 27,
    viewBox: "0 0 19 27",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.082 3.16634V9.62467C12.082 11.0713 12.5599 12.4147 13.3737 13.4997H5.6237C6.46328 12.3888 6.91536 11.0455 6.91536 9.62467V3.16634H12.082ZM15.957 0.583008H3.04036C2.32995 0.583008 1.7487 1.16426 1.7487 1.87467C1.7487 2.58509 2.32995 3.16634 3.04036 3.16634H4.33203V9.62467C4.33203 11.7688 2.6012 13.4997 0.457031 13.4997V16.083H8.16828V25.1247L9.45995 26.4163L10.7516 25.1247V16.083H18.5404V13.4997C16.3962 13.4997 14.6654 11.7688 14.6654 9.62467V3.16634H15.957C16.6674 3.16634 17.2487 2.58509 17.2487 1.87467C17.2487 1.16426 16.6674 0.583008 15.957 0.583008Z",
    fill: "#979797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnpinned);
export default __webpack_public_path__ + "static/media/unpinned.c5c029fd2a07ea46d9ffa8559b13e685.svg";
export { ForwardRef as ReactComponent };